import { render, staticRenderFns } from "./MediaOwnerTagSelect.vue?vue&type=template&id=4fc4a18c&"
import script from "./MediaOwnerTagSelect.vue?vue&type=script&lang=js&"
export * from "./MediaOwnerTagSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports